import { ProgressOverviewPageConfig } from '../../../../../domain/entity/version-report/VersionReportVersionEntity'
import { MasterSchedule } from '../master-schedule'
import { useProjectPrivateContext } from '../../../../context/projectContext'

type ProgressOverviewProps = {
  snapshotUuid: string
  config: ProgressOverviewPageConfig
}
export const ProgressOverview = ({
  snapshotUuid,
  config,
}: ProgressOverviewProps) => {
  const { projectUuid } = useProjectPrivateContext()
  return (
    <MasterSchedule
      projectUuid={projectUuid}
      targetUuids={config.targetUuids}
      rootUuid=""
      snapshotUuid={snapshotUuid}
    />
  )
}
